<template>
  <div class="page_bg">
    <!-- 顶部返回 -->
    <div class="back_top_name flex-r-sb-c" style=" padding: 0.32rem;background: #ffffff;font-size: 0.48rem;">
      <div class="top_icon" @click="backPath">
        <van-icon name="arrow-left" />
      </div>
      <div class="top_name">{{ title }}</div>
      <div class="top_icon" style="width:0.35rem;height:0.1rem">&nbsp;
      </div>
    </div>
    <!-- list -->
    <div class="order_list_box">
      <MyscrollList ref="myList01" :loading="listLoading" :list="proList" @myload="proload">
        <template #default="slotProps">
          <proCard01 :id="'classfily' + slotProps.item.productId" :info="slotProps.item" :type="2" />
        </template>
      </MyscrollList>
    </div>
  </div>
</template>

<script>
import './index.scss'
import MyscrollList from '@/components/MyscrollList'
import { apiWholesaleProduct_productList } from '@/api/pro'
import proCard01 from '@/components/pro_card_01'
export default {
  name: 'TagProList',
  components: { MyscrollList, proCard01 },
  data() {
    return {
      title: '',
      // 商品列表
      proSearch: { page: 1, limit: 10, brand: '' },
      proList: [],
      listLoading: false,
      update: true
    }
  },
  created() {
    this.title = this.$route.query.title
    this.proSearch.brand = this.$route.query.val
    this.$utils.cartNum(this.$store)
    this.getProList()
  },
  methods: {
    backPath() { window.history.back() },
    getProList() {
      this.$toast.loading({ message: '加载中...', forbidClick: true, loadingType: 'spinner', duration: 0 })
      apiWholesaleProduct_productList(this.proSearch).then(res => {
        this.$toast.clear()
        this.$refs.myList01.load_loading(false)
        this.proList = this.proList.concat(res.data.list)
        if (parseInt(res.data.total) === 0) { this.$refs.myList01.load_empty('list', true) } else {
          if (res.data.list.length === 0) { this.$refs.myList01.load_finished(true) } // 数据全部加载完成
        }
      })
    },
    proload() {
      this.$refs.myList01.load_loading(true)
      this.$utils.debounce(() => {
        this.proSearch.page = this.proSearch.page + 1
        this.getProList()
        // 加载状态结束
      }, 50)()
    }
  }
}
</script>

<style>
</style>
